var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scormController.file && !_vm.scormController.notFound)?_c('iframe',{staticClass:"full-view",attrs:{"src":_vm.scormController.file},on:{"load":_vm.load}}):_c('p-content-placeholder',{attrs:{"image":require('./background_404.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }